import SvgIcon from '@mui/material/SvgIcon';

const CameraLayout = (props) => {
    return (
        <SvgIcon {...props}>
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.625 3.75C4.58984 3.75 3.75 4.58984 3.75 5.625V9.375C3.75 10.4102 4.58984 11.25 5.625 11.25H9.375C10.4102 11.25 11.25 10.4102 11.25 9.375V5.625C11.25 4.58984 10.4102 3.75 9.375 3.75H5.625ZM5.625 13.75C4.58984 13.75 3.75 14.5898 3.75 15.625V19.375C3.75 20.4102 4.58984 21.25 5.625 21.25H9.375C10.4102 21.25 11.25 20.4102 11.25 19.375V15.625C11.25 14.5898 10.4102 13.75 9.375 13.75H5.625ZM13.75 5.625V9.375C13.75 10.4102 14.5898 11.25 15.625 11.25H19.375C20.4102 11.25 21.25 10.4102 21.25 9.375V5.625C21.25 4.58984 20.4102 3.75 19.375 3.75H15.625C14.5898 3.75 13.75 4.58984 13.75 5.625ZM17.5 13.75C16.9805 13.75 16.5625 14.168 16.5625 14.6875V16.5625H14.6875C14.168 16.5625 13.75 16.9805 13.75 17.5C13.75 18.0195 14.168 18.4375 14.6875 18.4375H16.5625V20.3125C16.5625 20.832 16.9805 21.25 17.5 21.25C18.0195 21.25 18.4375 20.832 18.4375 20.3125V18.4375H20.3125C20.832 18.4375 21.25 18.0195 21.25 17.5C21.25 16.9805 20.832 16.5625 20.3125 16.5625H18.4375V14.6875C18.4375 14.168 18.0195 13.75 17.5 13.75Z"
                    fill="white"
                />
            </svg>
        </SvgIcon>
    );
};

export default CameraLayout;
